export enum DerivedAvailabilityStatusLabelEnums {
  OutOfStock = 'outOfStock',
  Nla = 'noLongerAvailable',
  LowStock = 'lowStock',
  LowStockSubtext = 'lowStockSubtext',
  Bo = 'backOrder',
  BackOrderSubtext = 'availableSoon',
  Nya = 'notYetAvailable',
  AO = 'advancedOrder',
  Tna = 'temporarilyNotAvailable',
  Naw = 'notAvailableatthisWarehouse',
  Pbo = 'partialBackOrder',
  Cancelled = 'cancelled',
  ExclusiveForYou = 'exclusiveForYou',
}

export enum DerivedAvailabilityStatusComponentGroupKey {
  NOT_AVAILABLE_STATUSES = 'notAvailableStatuses',
  AVAILABLE_IN_FEW_STOCKS = 'availabelInFewStocks',
  CTA_DISABLED_STATUSES = 'CTADisabledStatuses',
  CTA_ENABLED_STATUSES = 'CTAEnabledStatuses',
  DISPOSITION_STATUSES = 'DispositionStatuses',
  CTA_DISABLED_SUBSCRIPTION_STATUSES = 'CTADisabledSubscriptionStatuses',
  PRE_LAUNCH_IGNORE_STATUSES = 'PreLaunchIgnoreStatuses',
}

export enum DerivedAvailabilityStatusComponentType {
  ONE_LINER = 'ONE_LINER',
  DEFAULT = 'DEFAULT',
  STOCK_STATUS_CART_ENTRY = 'STOCK_STATUS_CART_ENTRY',
  STOCK_STATUS_CART_ENTRY_MOBILE = 'STOCK_STATUS_CART_ENTRY_MOBILE',
  STOCK_STATUS_CARD_COMPONENT = 'STOCK_STATUS_CARD_COMPONENT',
  STOCK_STATUS_HORIZONTAL_CARD_COMPONENT = 'STOCK_STATUS_HORIZONTAL_CARD_COMPONENT',
  STOCK_STATUS_BUTTON = 'STOCK_STATUS_BUTTON',
  STOCK_STATUS_PRODUCT_SPEC = 'STOCK_STATUS_PRODUCT_SPEC',
  STOCK_STATUS_SEARCH_CARD = 'STOCK_STATUS_SEARCH_CARD',
  STOCK_STATUS_VARIANT = 'STOCK_STATUS_VARIANT',
  STOCK_STATUS_ABOCHECKBOX = 'STOCK_STATUS_ABOCHECKBOX',
  STOCK_STATUS_SEARCH_RESULT_CARD = 'STOCK_STATUS_SEARCH_RESULT_CARD',
  CHECKOUT_CARD = 'CHECKOUT_CARD',
  PRODUCT_SPEC = 'PRODUCT_SPEC',
}
